module.exports = __webpack_public_path__ + "img/文字版.0f146263.jpg";